module.exports = __webpack_public_path__ + "img/img1.a394180e.png";